export default "<div class=\"blue\">\n    <div class=\"white\">\n        <app-stadium-list></app-stadium-list>\n    </div>\n</div>";